<template lang="pug">    
    v-dialog(v-model="dialog" persistent max-width='600px' v-if="validDialog")
        v-card.mx-auto
            v-toolbar(dark color='white')
                v-btn(icon light @click='exit();')
                    v-icon mdi-close
                v-toolbar-title.text--primary Instant Voicemail
            v-card-text
                .text-center(v-if="isLoading")
                    v-progress-circular(
                        :size='100'
                        :width='10'
                        color='var(--volie-blue)'
                        indeterminate
                        style="margin-top: 75px;"
                    )

                .pt-md-6(v-else)

                    v-alert(
                        border="left"
                        dense
                        type="warning"
                        outlined
                    )
                        | Please wait until you hear the <strong>BEEP</strong> to leave the voicemail.
                        br
                        | If you leave it before the beep, the customer <strong>may not</strong> receive the voicemail.

                    v-container
                        v-form(ref="form")
                            v-row
                                v-col(cols='12')
                                    v-select(
                                        label='Instant Voicemail'
                                        v-model="campaignInstantVoicemailMp3ID"
                                        :items="campaignInstantVoicemailMp3s"
                                        item-text="mp3_name"
                                        item-value="campaign_instant_voicemail_mp3_id"
                                        clearable
                                    )

            v-card-actions.text-right
                v-spacer
                    v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='exit();')
                        v-icon mdi-window-close
                        | Close
                    v-btn.ma-2(color="green" outlined ripple :disabled="!validCampaignInstantVoicemailMp3ID" @click='leaveInstantVoicemail();')
                        v-icon mdi-content-save
                        | Leave Instant Voicemail

</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { GetCampaignInstantVoicemailMp3s, LeaveInstantVoicemail } from "@/data";
    import VolieState from '@/store';

    export default Vue.extend({
        data() {
            return {
                campaignInstantVoicemailMp3s: [],
                campaignInstantVoicemailMp3ID: null,
                dialog: true,
                isLoading: false,
            }
        },
        methods: {
            exit(snackbarColor, snackbarText) {
                this.dialog = false;
                this.closeInstantVoicemail(snackbarColor, snackbarText);
            },
            getCampaignInstantVoicemailMp3s() {
                // Verify
                if (!(this.call?.campaign_id > 0)) {
                    return;
                }

                const options = {
                    ownable_type: "user",
                    ownable_id: VolieState.currentUser().user_id,
                }

                // Load
                this.isLoading = true;
                GetCampaignInstantVoicemailMp3s(this.call?.campaign_id, options).then((response) => {
                    if (response?.Data?.campaign_instant_voicemail_mp3s?.length > 0) {
                        this.campaignInstantVoicemailMp3s = response.Data.campaign_instant_voicemail_mp3s;
                    }

                    this.isLoading = false;
                });
            },
            leaveInstantVoicemail() {

                // Verify
                if (!this.validDialog || !this.validCampaignInstantVoicemailMp3ID) {
                    return;
                }

                // Init
                const options = {
                    campaign_instant_voicemail_mp3_id: this.campaignInstantVoicemailMp3ID,
                }

                // Load
                this.isLoading = true;
                LeaveInstantVoicemail(this.call?.id, options).then((response) => {
                    if (response?.Data?.ok === true) {
                        this.exit("green", "Successfully left instant voicemail");
                    } else {
                        this.exit("error", "An error occurred while leaving instant voicemail");
                    }
                });
            },
        },
        computed: {
            validCampaignInstantVoicemailMp3ID() {
                return this.campaignInstantVoicemailMp3ID > 0;
            },
            validDialog() {
                return this.call?.id > 0;
            },
        },
        components: {
        },
        props: {
            call: Object,
            closeInstantVoicemail: Function,
        },
        created() {
            this.getCampaignInstantVoicemailMp3s();
        },
    });
</script>

<style lang="scss" scoped>
</style>
